import Box from "@material-ui/core/esm/Box";
import InfoOutlined from "@material-ui/icons/esm/InfoOutlined";
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadButton } from 'components/Button';
import DatePicker from 'components/DatePicker/DatePicker';
import { ARCHIVED_PASSINGS_DOWNLOAD_URL } from 'constants/urls';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import downloadBlob from 'utils/download/downloadBlob';
import isNorwegian from 'utils/language/isNorwegian';
import useStyle from './PassingStyles';
import InventoryIcon from 'components/Icons/InventoryIcon';
import { LIGHT_PRIMARY } from 'constants/colors';
export default function ArchivedPassingsDownload({
  disabled,
  obeNumber
}) {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    archivedButtons,
    column
  } = useStyle();
  const [isDownloadingPassings, setIsDownloadingPassings] = useState(false);
  const {
    customer
  } = useCurrentCustomer();
  const buttonsDisabled = disabled || isDownloadingPassings || !customer?.id;
  const [dates, setDates] = useState({});
  const handleDateChange = input => {
    setDates(props => ({
      ...props,
      dateFrom: input.startDate?.toDate(),
      dateTo: input.endDate?.toDate()
    }));
  };
  const downloadArchivedPassings = async () => {
    try {
      setIsDownloadingPassings(true);
      await downloadBlob(ARCHIVED_PASSINGS_DOWNLOAD_URL(customer?.id), `${t('titles.passings')}_${customer?.id}.csv`, 'POST', {
        dateFrom: dates.dateFrom,
        dateTo: dates.dateTo,
        format: 'csv',
        language: isNorwegian(i18n) ? 'No' : 'Eng',
        obeNumber
      });
    } catch {
      enqueueSnackbar(t('error.download_archived_passings'), {
        variant: 'error'
      });
    } finally {
      setIsDownloadingPassings(false);
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Box, {
    bgcolor: LIGHT_PRIMARY,
    padding: '2.5rem',
    borderRadius: '5px',
    fontSize: 'medium',
    position: 'relative'
  }, /*#__PURE__*/React.createElement(InfoOutlined, {
    style: {
      position: 'absolute',
      top: '1rem',
      left: '1rem'
    }
  }), t('passings.information_box_archive') + ' ', /*#__PURE__*/React.createElement(InventoryIcon, {
    title: t('invoices.archived_info')
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: '0.5',
      fontStyle: 'italic'
    }
  }, ' ' + t(`invoice_status.paid`))), /*#__PURE__*/React.createElement("div", {
    className: archivedButtons
  }, /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: handleDateChange,
    useUtc: true
  })), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    disabled: buttonsDisabled,
    loading: isDownloadingPassings,
    onClick: downloadArchivedPassings
  }, t('buttons.download_archived_passings')))));
}
ArchivedPassingsDownload.defaultProps = {
  obeNumber: undefined
};